import React from "react";
import { NumberTicker } from "../NumberTicker";

interface Iinitiative {
  title: string;
  description: string;
}

const TrainingImpact: React.FC = () => {
  const initiatives: Iinitiative[] = [
    {
      title: " India's Leading Insurance Companies trust us!",
      description:
        "Trusted by 70% of insurance companies nationwide for delivering domain-specific training that drives results.",
    },
    {
      title: " Candidates Trained for top organizations",
      description:
        "Helped professionals climb the corporate ladder with confidence.",
    },
    {
      title: "Comprehensive Training Solutions for Every Industry",
      description:
        "Seamless execution of online and offline training programs tailored to diverse professional needs.",
    },
    {
      title: "Revolutionizing Learning with Advanced LMS Technology",
      description:
        "Empowering organizations with a cutting-edge Learning Management System for efficient, engaging, and scalable employee training.",
    },
  ];

  return (
    <div className="w-full flex justify-center items-center">
      <div className="flex flex-col w-full">
        <div className="max-w-4xl">
          <h4 className=" text-2xl md:text-3xl text-[#2A3342] pt-5 w-full max-w-3xl lg:text-4xl">
            Impact & Achievements
          </h4>
          <div className="font-medium text-sm pt-2 text-[#182152] lg:pt-4 xl:pt-6 lg:text-base xl:text-lg">
            A Legacy of Excellence
          </div>
          <p className="font-light pt-2 max-w-[52rem] lg:text-lg xl:text-xl lg:pt-4 xl:pt-6 text-[#556987]">
            Candidates trained to date, we've helped professionals climb the
            corporate ladder with confidence.
          </p>
        </div>
        <div className="flex w-full justify-center items-center lg:justify-normal pt-10">
          <div className="grid gap-5 md:grid-cols-3">
            <div className="grid md:grid-cols-2 md:col-span-2 gap-5">
              {initiatives.map((initiative, index) => {
                return (
                  <div
                    key={initiative.title}
                    className="flex flex-col gap-2 py-5"
                  >
                    <h3
                      className={`font-bold text-[#333F51] justify-center text-center text-2xl ${index === 0 ? "flex text-5xl" : "hidden"}`}
                    >
                      <NumberTicker value={70} className="text-[#333F51]" />%
                    </h3>
                    <h3
                      className={`font-bold text-[#333F51] justify-center text-center text-3xl ${index === 1 ? "flex text-5xl" : "hidden"}`}
                    >
                      <NumberTicker value={1} className="text-[#333F51]" />{" "}
                      Million+
                    </h3>
                    <div className="flex w-full justify-center items-center">
                      <h5 className="font-normal text-center lg:text-lg w-full max-w-xs xl:text-xl">
                        {initiative.title}
                      </h5>
                    </div>
                    <div className="flex justify-center items-center w-full">
                      <p className="text-[#556987] lg:text-base text-xs text-center max-w-xs">
                        {initiative.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="w-full flex justify-center items-center relative h-full">
              <img
                src="/training/1m.png"
                alt="Base workspace"
                className="w-56 md:w-96 lg:w-[34rem] xl:h-[30rem] xl:w-[34rem] relative"
              />
              {/* <img
                src="/skill/work.png"
                alt="Overlapping workspace"
                className="absolute w-72 top-8 xl:h-96 -right-4 xl:-right-16 md:top-3 md:-right-8 lg:-right-12 lg:-top-16 xl:-top-[14rem] md:max-w-sm flex"
              /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainingImpact;
